<template>
    <div class="personnel_container">
        <!-- 搜索区域 -->
        <global-tag>
            <span slot="title">服务人员</span>
            <div class="search" slot="search">
                <el-form label-width="100px">
                    <el-row>
                        <el-col :span="4">
                            <el-form-item label="姓名：">
                                <el-input
                                    v-model="name"
                                    placeholder="请输入名称"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" style="margin-left: 10px">
                            <el-form-item label="身份证号码：">
                                <el-input
                                    v-model="personIdentity"
                                    placeholder="请输入身份证号码"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="3" :offset="1">
                            <el-button
                                type="primary"
                                class="searchBtns"
                                @click="queryList"
                                >搜索</el-button
                            >
                        </el-col>
                        <el-col :span="4">
                            <el-button
                                type="info"
                                class="resetReach"
                                @click="handleResert"
                                >清除条件</el-button
                            >
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </global-tag>
        <div class="table_title">
            <div class="btn_group">
                <el-button-group>
                    <el-button
                        type="success"
                        icon="el-icon-plus"
                        class="openBtns"
                        @click="handleTableForm('新增')"
                        >新增</el-button
                    >
                </el-button-group>
            </div>
            <div class="screen_container">
                <el-button-group>
                    <el-button
                        type="primary"
                        icon="el-icon-refresh"
                        class="dropRests"
                        @click="Reset1"
                    ></el-button>
                    <!-- <el-button type="primary" style="padding: 10px 20px"> -->
                    <el-dropdown
                        class="dropdown1"
                        trigger="click"
                        :hide-on-click="false"
                    >
                        <span class="el-dropdown-link">
                            <i
                                class="el-icon-s-grid el-icon--right"
                                style="color: #fff"
                            ></i>
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu
                            slot="dropdown"
                            class="table_checkbox"
                        >
                            <el-dropdown-item>
                                <el-checkbox-group
                                    v-model="tableChekbox"
                                    @change="tableChekboxChange"
                                >
                                    <el-checkbox label="序号"></el-checkbox>
                                    <br />
                                    <el-checkbox label="姓名"></el-checkbox>
                                    <br />
                                    <el-checkbox label="联系方式"></el-checkbox>
                                    <br />
                                    <el-checkbox label="身份证号"></el-checkbox>
                                    <br />
                                    <el-checkbox label="创建人"></el-checkbox>
                                    <br />
                                    <el-checkbox label="操作"></el-checkbox>
                                </el-checkbox-group>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <!-- </el-button> -->
                </el-button-group>
            </div>
        </div>
        <!-- 页面表格 -->
        <div class="table_container">
            <el-table
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                height="550"
                :header-cell-style="{ background: '#e6e6e6', color: '#000' }"
                border
            >
                <el-table-column
                    type="index"
                    width="60px"
                    label="序号"
                    align="center"
                    show-overflow-tooltip
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '序号'
                        ) != -1
                    "
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    min-width="120px"
                    label="姓名"
                    prop="personName"
                    :show-overflow-tooltip="true"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '姓名'
                        ) != -1
                    "
                ></el-table-column>
                <el-table-column
                    align="center"
                    min-width="120px"
                    label="联系方式"
                    prop="personPhone"
                    :show-overflow-tooltip="true"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '联系方式'
                        ) != -1
                    "
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    min-width="150px"
                    label="身份证号"
                    prop="personIdentity"
                    :show-overflow-tooltip="true"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '身份证号'
                        ) != -1
                    "
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="createPersonName"
                    min-width="60px"
                    label="创建人"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '创建人'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    width="150px"
                    align="center"
                    label="操作"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '操作'
                        ) != -1
                    "
                >
                    <template slot-scope="scope">
                        <el-tooltip
                            class="item"
                            effect="dark"
                            content="查看"
                            placement="top-start"
                        >
                            <img
                                src="../assets/img/detail.png"
                                style="cursor: pointer"
                                @click="handleTableForm('详情', scope.row)"
                            />
                        </el-tooltip>
                        <el-tooltip
                            effect="dark"
                            content="编辑"
                            placement="top-start"
                        >
                            <img
                                src="../assets/img/table_edit.png"
                                @click="handleTableForm('编辑', scope.row)"
                                style="margin-left: 12px; cursor: pointer"
                            />
                        </el-tooltip>
                        <el-tooltip
                            class="item"
                            effect="dark"
                            content="删除"
                            placement="top-start"
                        >
                            <img
                                src="../assets/img/table_delete.png"
                                alt
                                @click="deleteItem(scope.row)"
                                style="margin-left: 12px; cursor: pointer"
                            />
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination_container">
            <el-pagination
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageConfig.total"
                :page-size="pageConfig.pageSize"
                :current-page.sync="pageConfig.pageNo"
                @size-change="handletableSize"
                @current-change="handleTableChange"
            ></el-pagination>
        </div>
        <!-- 表格表单弹窗 -->
        <el-dialog
            :title="dialogVisibleTitle"
            :visible.sync="dialogVisible"
            width="40%"
            :close-on-click-modal="false"
            class="dialog_container"
            @close="dialogVisibleClone"
        >
            <div class="dialog_content">
                <el-form
                    label-position="left"
                    label-width="100px"
                    ref="formData"
                    :model="formData"
                    :rules="formDataRules"
                    :disabled="dialogVisibleTitle == '详情'"
                >
                    <el-form-item label="姓名：" prop="staffId">
                        <el-select
                            v-model="formData.staffId"
                            filterable
                            remote
                            :disabled="
                                dialogVisibleTitle === '详情' ||
                                dialogVisibleTitle === '编辑'
                            "
                            ref="fuzzySearch"
                            style="width: 100%"
                            placeholder="请输入关键词"
                            :remote-method="remoteMethod"
                            @change="handleSelect"
                            @click.native="clearForm"
                            :loading="loading"
                            solt="empty"
                        >
                            <el-option
                                v-for="item in options"
                                :key="item.id"
                                :label="item.personName"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="联系方式：" prop="personPhone">
                        <el-input
                            v-model="formData.personPhone"
                            placeholder="请输入"
                            disabled
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="身份证号：" prop="personIdentity">
                        <el-select
                            v-model="formData.personIdentity"
                            filterable
                            remote
                            style="width: 100%"
                            placeholder="请输入关键词"
                            :disabled="
                                dialogVisibleTitle === '详情' ||
                                dialogVisibleTitle === '编辑'
                            "
                            :remote-method="remoteMethod1"
                            @change="handleSelect"
                            @click.native="clearForm1"
                            :loading="loading"
                        >
                            <el-option
                                v-for="item in options"
                                :key="item.id"
                                :label="item.personIdentity"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    @click="savedata"
                    v-if="dialogVisibleTitle != '详情'"
                    >确 定</el-button
                >
                <el-button @click="cancels">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import request from "@/utils/request.js"
import common from "../../../utils/common.js"
import globalTag from "../components/globalTag"
import { post, get } from "@/api/requrestHttp.js"
import { discriCard, chekCode, chekPhone } from "../util"

export default {
    name: "proManage",
    data() {
        var checkIdCode = (rule, value, callback) => {
            if (!chekCode(value)) {
                return callback(new Error("身份证号格式错误"))
            }
            const info = discriCard(value)
            //this.formData.sex = info.sex
            callback()
        }
        var chekPhone = (rule, value, callback) => {
            let validatePhone = /^1[0-9]{10}$/
            if (!validatePhone.test(value)) {
                return callback(new Error("手机号格式错误"))
            }
            callback()
        }
        return {
            defaultProps: {
                children: "children",
                label: "label",
            },
            orgLevels: "",
            isdisabled: false,
            orgList: [],
            arrOrgList: [],
            name: "", //人员名称
            personPhone: "", //手机号
            personIdentity: "", //身份证
            currentPage: 1, //默认展示第一页
            total: 0,
            pageNo: 1,
            pageSize: 10,
            tableData: [],
            formData: {
                //id: "",
                //table表单
                name: "",
                sex: "",
                deptId: "",
                personPhone: "",
                personIdentity: "",
                status: "",
                orgId: "",
                orgName: "",
                staffId: "",
            },
            formDataRules: {
                staffId: [
                    {
                        required: true,
                        message: "姓名",
                        trigger: "blur",
                    },
                ],
                // orgName:[{required: true, message: '人员名称不能为空', trigger: 'change' }],
                personPhone: [
                    {
                        required: true,
                        message: "联系方式不能为空",
                        trigger: "blur",
                    },
                    { validator: chekPhone, trigger: "blur" },
                ],
                personIdentity: [
                    {
                        required: true,
                        message: "身份证不能为空",
                        trigger: "blur",
                    },
                    { validator: checkIdCode, trigger: "blur" },
                ],
            },
            pageConfig: {
                pageSize: 10,
                total: 0,
                pageNo: 1,
            },
            dialogVisible: false, //table表单弹窗
            dialogVisibleTitle: "", //table表单弹窗title
            tempTableChekbox: [
                "序号",
                "姓名",
                "联系方式",
                "身份证号",
                "创建人",
                "操作",
            ],
            tableChekbox: [
                "序号",
                "姓名",
                "联系方式",
                "身份证号",
                "创建人",
                "操作",
            ],
            addDialog: false, //部门弹窗里面新增表单
            addDialogTitle: "新增", //部门弹窗里面新增表单title
            addFormData: {
                //部门弹窗里面新增表form
                deptName: "",
                status: "0",
            },
            departmentList: [],
            departmentDialogTitle: "查看", //部门弹窗title
            departmentDialog: false, //部门弹窗
            selectDepartmentList: [],
            loading: false,
            options: [],
        }
    },
    components: {
        globalTag,
    },
    inject: ["reload"], //注入
    methods: {
        getSex() {
            let sex = this.formData.personIdentity.substring(16, 17)
            if (sex % 2 === 0) this.formData.sex = "2"
            else this.formData.sex = "1" //1男2女
        },
        getchangeList(query, query1) {
            let dataId = ""
            if (this.dialogVisibleTitle == "新增") {
                dataId = this.$store.state.info.dataId
            } else {
                dataId = ""
            }
            this.$http
                .request({
                    url: "/ypt/admin/serviceStaff/info/findList",
                    method: "POST",
                    data: {
                        pageNo: 1,
                        pageSize: -1,
                        personName: query,
                        personIdentity: query1,
                        // dataId: dataId,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content != null) {
                            this.options = res.content.list
                        } else {
                            this.options = []
                        }
                        this.loading = false
                    }
                })
        },
        remoteMethod(query) {
            if (query !== "") {
                this.loading = true
                this.getchangeList(query, "")
            } else {
                this.options = []
            }
        },
        remoteMethod1(query) {
            if (query !== "") {
                this.loading = true
                this.getchangeList("", query)
            } else {
                this.options = []
            }
        },
        async handleSelect(val) {
            // console.log(val)
            let item = {}
            this.options.forEach((item) => {
                if (item.id == val) {
                    this.formData.personName = JSON.parse(
                        JSON.stringify(item)
                    ).personName
                    this.formData.personPhone = JSON.parse(
                        JSON.stringify(item)
                    ).personPhone
                    this.formData.personIdentity = JSON.parse(
                        JSON.stringify(item)
                    ).personIdentity
                    this.formData.staffId = JSON.parse(JSON.stringify(item)).id
                    // console.log(this.formData.staffId, "this.formData.staffId")
                }
            })
            this.$forceUpdate()
        },
        //监控姓名是否为空
        clearForm(val) {
            if (val) {
                if (this.dialogVisibleTitle == "新增") {
                    this.$set(this.formData, "staffId", "")
                    this.formData = {}
                }
            }
        },
        //监控身份证是否为空
        clearForm1(val) {
            if (val) {
                if (this.dialogVisibleTitle == "新增") {
                    this.$set(this.formData, "staffId", "")
                    this.formData = {}
                }
            }
        },
        sexChange(val) {
            console.log(val)
        },
        loopNode(node, arr) {
            if (node.parent == null) {
                return arr
            } else {
                arr.push(node.data.orgId)
                this.loopNode(node.parent, arr)
            }
        },
        handleEditNodeClick(data, node) {
            const clickNode = this.$refs.tree.getNode(node)
            const arr = []
            this.loopNode(clickNode, arr)
            this.arrOrgList = arr
            let obj = common.organization(this.arrOrgList, this.orgLevels)
            this.$set(this.formData, "orgId", data.orgId)
            this.$set(this.formData, "parentId", data.parentId)
            this.$set(this.formData, "orgType", data.orgType)
            this.$set(this.formData, "orgName", data.label)
            this.$set(this.formData, "qujiId", obj.qujiId)
            this.$set(this.formData, "shengjiId", obj.shengjiId)
            this.$set(this.formData, "shijiId", obj.shijiId)
            this.$set(this.formData, "stationId", obj.stationId)
            this.$set(this.formData, "shequjiId", obj.shequjiId)
            this.$refs["selectBoxRef"].handleClose()
        },
        //获取组织机构
        getOrg() {
            this.$http
                .request({
                    url: "/rbac/admin/org/info/OrgTreelist",
                    method: "POST",
                    data: { isValid: 1 },
                })
                .then((res) => {
                    if (res.code === 200) {
                        for (let i in res.content) {
                            if (res.content[i].orgType == "1") {
                                this.orgList.push(res.content[i])
                            }
                            this.orgLevels = res.content[0].orgLevel
                        }
                    }
                })
        },

        // 保留条件刷新
        Reset1() {
            this.showlist(true)
            this.tableChekbox = ["序号", "姓名", "联系方式", "身份证号", "操作"]
        },

        // 页面刷新
        Reset() {
            this.reload()
        },
        //table列checkbox发生变化
        tableChekboxChange(val) {
            this.tempTableChekbox = val.map((item) => item)
        },
        //服务人员信息
        async showlist(e) {
            let params = {
                pageNo: this.pageConfig.pageNo,
                pageSize: this.pageConfig.pageSize,
            }
            params = Object.assign({}, params, {
                ...e,
            })
            await request({
                url: "/jjyl/admin/serviceProviderPerson/info/findList",
                method: "POST",
                data: params,
            }).then((res) => {
                this.pageConfig.total = res.content.count
                this.tableData = res.content.list
                this.total = res.content.count
            })
        },
        cancels() {
            this.dialogVisible = false
        },
        // 保存
        async savedata() {
            let obj = common.organization(this.arrOrgList, this.orgLevels)
            if (this.dialogVisibleTitle == "编辑") {
                this.formData.staffId = this.formData.serviceId
            }
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    let params = {
                        ...this.formData,
                    }
                    params = Object.assign({}, params)
                    request({
                        url: "/jjyl/admin/serviceProviderPerson/info/insertOrUpdate",
                        method: "POST",
                        data: params,
                    }).then((res) => {
                        if (res.code === 200) {
                            this.isdisabled = true
                            this.$message.success("保存成功")
                            this.showlist()
                        } else {
                            //console.log(res)
                            this.$message.error(res.message)
                        }
                        this.dialogVisible = false
                    })
                } else {
                    return false
                }
            })
        },
        // 查看
        async query(data) {
            // let params = {
            //     id: data.id,
            // }
            // params = Object.assign({}, params)
            // await request({
            //     url: "/jjyl/admin/personMsg/info/getById",
            //     method: "POST",
            //     data: params,
            // }).then((res) => {
            //     console.log(res)
            //     this.formData = res.content
            // })
        },
        // 删除
        deleteItem(data) {
            this.$confirm("确认永久删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                request({
                    url: "/jjyl/admin/serviceProviderPerson/info/deleteById",
                    method: "POST",
                    data: { id: data.id },
                }).then((res) => {
                    if (res.code == 201) {
                        this.$message.warning(res.message)
                    }
                    this.showlist()
                })
            })
        },

        //老人信息列表pagesize发生改变
        handletableDataSize(val) {
            this.pageSize = val
            //this.departmentlist()
        },
        //老人信息列表页码发生改变
        handleTableDataChange(val) {
            this.pageNo = val
            // this.departmentlist()
        },
        //老人信息列表pagesize发生改变
        handletableSize(val) {
            this.pageConfig.pageSize = val
            this.showlist()
        },
        //老人信息列表页码发生改变
        handleTableChange(val) {
            this.pageConfig.pageNo = val
            this.showlist()
        },
        // 新增
        // async save() {
        //     let params = {
        //         ...this.addFormData,
        //     }
        //     params = Object.assign({}, params)
        //     await request({
        //         url: "/jjyl/admin/deptManage/info/insertOrUpdate",
        //         method: "POST",
        //         data: params,
        //     }).then((res) => {})
        //     this.addDialog = false
        //    // this.departmentlist()
        // },
        // 删除
        deleteItem2(data) {
            this.$confirm("确认永久删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                request({
                    url: "/jjyl/admin/deptManage/info/deleteById",
                    method: "POST",
                    data: { id: data.id },
                }).then((res) => {
                    this.showlist()
                    this.$message({
                        type: "success",
                        message: "删除成功!",
                    })
                    //this.departmentlist()
                })
            })
        },
        // 查看
        async look(data) {
            let params = {
                id: data.id,
            }
            params = Object.assign({}, params)
            await request({
                url: "/jjyl/admin/deptManage/info/getById",
                method: "POST",
                data: params,
            }).then((res) => {
                console.log(res)
                this.addFormData = res.content
            })
        },
        // 查询
        queryList() {
            post("/jjyl/admin/serviceProviderPerson/info/findList", {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                name: this.name,
                personPhone: this.personPhone,
                personIdentity: this.personIdentity,
            }).then((res) => {
                if (res.content == null) {
                    this.tableData = []
                } else {
                    this.tableData = res.content.list
                    this.total = res.content.count
                }
            })
        },
        resert() {
            this.formData = {
                name: "",
                sex: "",
                deptId: "",
                personPhone: "",
                personIdentity: "",
                status: "",
            }
        },
        handleTableForm(title, data) {
            //处理table表格表单
            this.dialogVisibleTitle = title
            this.dialogVisible = true
            this.isdisabled = false
            switch (title) {
                case "新增":
                    break
                case "详情":
                    this.looks(data)
                    break
                case "编辑":
                    this.looks(data)
                    break
            }
        },
        // 查看
        looks(date) {
            let params = {
                id: date.id,
            }
            params = Object.assign({}, params)
            request({
                url: "/jjyl/admin/serviceProviderPerson/info/getById",
                method: "POST",
                data: params,
            }).then((res) => {
                this.formData = res.content
                this.formData.serviceId = res.content.staffId
                this.formData.staffId = res.content.personName
            })
        },

        handleTableAddForm(title, data) {
            //表单内新增
            this.addDialogTitle = title
            this.addDialog = true
            console.log(title, "title")
            switch (title) {
                case "新增":
                    console.log(title, "新增")
                    this.addFormData.id = ""
                    break
                case "编辑":
                    console.log(title, "编辑")
                    this.look(data)
                    break
            }
        },
        //table表格表单弹窗关闭时事件
        dialogVisibleClone() {
            this.formData.name = ""
            this.formData.sex = ""
            this.formData.deptId = ""
            this.formData.personPhone = ""
            this.formData.personIdentity = ""
            this.formData.status = ""
            this.formData.orgName = ""
            delete this.formData.id
            this.$refs.formData.resetFields()
        },
        addDialogClose() {
            //table表格表单新增弹窗关闭时事件
            this.addFormData.deptName = ""
            this.addFormData.status = "0"
        },
        departmentDialogTitleClose() {
            // 部门弹窗关闭时事件
            this.pageSize = 10
            this.pageNo = 1
            //this.departmentlist()
        },
        handleResert() {
            this.name = "" //人员名称
            this.personPhone = "" //手机号
            this.personIdentity = "" //身份证
            this.pageSize = 10
            this.pageNo = 1
            this.queryList()
        },
    },
    created() {
        this.getOrg()
        this.showlist()
        // this.departmentlist()
    },
}
</script>

<style lang="less" scoped>
.table_container {
    width: 100%;
}

/deep/ .personnel_dialog {
    .add_table {
        margin-top: 24px;
    }

    .el-dialog__footer {
        display: none;
    }
}
</style>